import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BillFetchResult,
  BillFetchPayload,
} from "features/bbps/biller/billerFlowTypes";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

interface BillFetchState {
  loading: boolean;
  data?: BillFetchResult;
  error?: NormalizedError | null;
}

const initialState: BillFetchState = {
  loading: false,
  data: undefined,
  error: null,
};

const billFetchSlice = createSlice({
  name: "billFetch",
  initialState,
  reducers: {
    billFetchRequested(state, _action: PayloadAction<BillFetchPayload>) {
      state.loading = true;
      state.error = null;
    },
    billFetchSucceeded(state, action: PayloadAction<BillFetchResult>) {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    billFetchFailed(state, action: PayloadAction<NormalizedError>) {
      state.loading = false;
      state.error = action.payload;
    },
    billFetchReset() {
      return initialState;
    },
  },
});

export const {
  billFetchRequested,
  billFetchSucceeded,
  billFetchFailed,
  billFetchReset,
} = billFetchSlice.actions;

export default billFetchSlice.reducer;
